var map = {
	"./Article": 54620,
	"./Article/": 54620,
	"./Article/index": 54620,
	"./Article/index.jsx": 54620,
	"./Article/styles.module.css": 50574,
	"./BlankLayout": 30643,
	"./BlankLayout/": 30643,
	"./BlankLayout/index": 30643,
	"./BlankLayout/index.jsx": 30643,
	"./BlankLayout/styles.module.css": 59348,
	"./ContactLayout": 73676,
	"./ContactLayout/": 73676,
	"./ContactLayout/SimpleCheckbox": 10903,
	"./ContactLayout/SimpleCheckbox/": 10903,
	"./ContactLayout/SimpleCheckbox/index": 10903,
	"./ContactLayout/SimpleCheckbox/index.jsx": 10903,
	"./ContactLayout/SimpleCheckbox/styles.module.css": 79498,
	"./ContactLayout/SimpleRadioButton": 59473,
	"./ContactLayout/SimpleRadioButton/": 59473,
	"./ContactLayout/SimpleRadioButton/index": 59473,
	"./ContactLayout/SimpleRadioButton/index.jsx": 59473,
	"./ContactLayout/SimpleRadioButton/styles.module.css": 45046,
	"./ContactLayout/index": 73676,
	"./ContactLayout/index.jsx": 73676,
	"./ContactLayout/styles.module.css": 13025,
	"./GalleryLayout": 96069,
	"./GalleryLayout/": 96069,
	"./GalleryLayout/index": 96069,
	"./GalleryLayout/index.jsx": 96069,
	"./GalleryLayout/styles.module.css": 34853
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39077;